import React, { type ComponentType } from 'react';
import { QUICKSTART_UI_STATUS } from '@atlassian/jira-onboarding-quickstart-core/src/common/constants.tsx';
import { useQuickstartUiStatus } from '@atlassian/jira-onboarding-quickstart-core/src/services/index.tsx';
import { useCurrentRoute } from '@atlassian/jira-platform-router-utils/src/index.tsx';
import { JswQuickStartShouldRender } from '@atlassian/jira-software-onboarding-quickstart/src/JswQuickStartShouldRender.tsx';
import { JswOnboardingButton } from '@atlassian/jira-software-onboarding-quickstart/src/ui/async.tsx';
import { useQueryParam } from '@atlassian/react-resource-router';
import { shouldRouteSkipOnboarding } from '../../common/utils.tsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Onboarding: ComponentType<Record<any, any>> = () => {
	const route = useCurrentRoute();
	const [configQueryParam] = useQueryParam('config');
	const [quickstartStatus] = useQuickstartUiStatus();

	if (shouldRouteSkipOnboarding(route.name, configQueryParam)) {
		return null;
	}

	const shouldRenderOnboardingButton =
		quickstartStatus !== QUICKSTART_UI_STATUS.NOT_LOADED &&
		quickstartStatus !== QUICKSTART_UI_STATUS.DISMISSED;

	return (
		<>
			<JswQuickStartShouldRender />
			{shouldRenderOnboardingButton && <JswOnboardingButton />}
		</>
	);
};

export default Onboarding;
